import { DSPromotedProduct } from 'shared-definitions/types'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { ApiPromotedProduct } from 'data-source/types.wp'
import { pLinkExternalMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

const isPromotedEmpty = (input: ApiPromotedProduct): boolean => {
  const iterableInput = Object.entries(input)
  let isEmpty = true
  for (const [, value] of iterableInput) {
    if (
      (typeof value === 'string' && value.length > 0) ||
      (Array.isArray(value) && value.length > 0)
    ) {
      isEmpty = false
      break
    }
  }

  return isEmpty
}

export function productPromotedMapper(
  input: ApiPromotedProduct,
  opts: PLinkMapperOpts
): DSPromotedProduct | null {
  const isEmpty = isPromotedEmpty(input)
  if (isEmpty) {
    return null
  }

  return {
    title: input.title,
    excerpt: input.excerpt,
    image: input.image ? imageMapper(input.image, opts) : null,
    features: input.features,
    awardLabel:
      input.award_icon && input.award_text
        ? {
            icon: imageMapper(input.award_icon, opts),
            title: input.award_text,
          }
        : null,
    advertiseButton: {
      pLink: pLinkExternalMapper(input.button_link),
      label: input.button_text,
    },
  }
}
